// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tab-items[data-v-d8208b5c] {\n  min-width: 500px;\n  max-width: 90vw;\n  min-height: 500px;\n  max-height: calc(90vh - 140px);\n}\n", ""]);
// Exports
module.exports = exports;
